import { PARTITION } from './constants';

const selectPartition = (state: any) => state[PARTITION];
const selectCount = (state: any) => selectPartition(state).count;

export default {
  selectPartition,
  selectCount,
};
